<template>
  <div>
    <EnterpriseGraphTab />

    <MySkeleton idx :id="'bm'+titles[0].label">
      <title-block v-if="titles[0].num">
        <template>
          <template slot="title">{{titles[0].label}}</template>
          <div class="brief">
            {{brief}}
            <span class="showMoreText" v-show="showMoreText" @click="showMore">更多</span>
            <!-- 沁州黄小米为主导产品，集良种繁育、科研示范、基地建设、生产加工，市场营销于一体的省级农业产业化龙头企业。于1982年，2002年组建集团，注册资本1.15亿元，现有员工230名，其中高级农艺师3名，沁州黄谷子专家1名，技术员18名。种植基地面积5万亩，遍及全县13个乡镇，193年行政村，涉及2万多农户，年产沁州黄小米万吨以上。营销网络遍及北京、上海、齐齐哈尔等国内大中型城市和我省的地、市级以上市区，产品进入了全国1000多个大中小型超市，其中A级超市120多个。 -->
          </div>
        </template>
      </title-block>
    </MySkeleton>

    <MySkeleton :id="'bm'+titles[1].label" @update="_ => handleCurrentChange(1, 1)">
      <title-block v-if="titles[1].num && activeInfo">
        <template slot="title">{{titles[1].label}}</template>
        <div class="table mt-10" style="margin-top:16px">
          <el-row>
            <el-col :span="5">法定代表人</el-col>
            <el-col :span="7">{{ disposal('法定代表人') }}</el-col>
            <el-col :span="5">经营状态</el-col>
            <el-col :span="7">{{ disposal('经营状态') }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">注册资本</el-col>
            <el-col :span="7">{{ disposal('注册资本') }}</el-col>
            <el-col :span="5">登记机关</el-col>
            <el-col :span="7">{{ disposal('登记机关') }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">成立日期</el-col>
            <el-col :span="7">{{ disposal('成立日期') }}</el-col>
            <el-col :span="5">核准日期</el-col>
            <el-col :span="7">{{ disposal('核准日期') }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">统一社会信用代码</el-col>
            <el-col :span="7">{{ disposal('统一社会信用代码') }}</el-col>
            <el-col :span="5">组织机构代码</el-col>
            <el-col :span="7">{{ disposal('组织机构代码') }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">纳税人识别号</el-col>
            <el-col :span="7">{{ disposal('纳税人识别号') }}</el-col>
            <el-col :span="5">工商注册号</el-col>
            <el-col :span="7">{{ disposal('工商注册号') }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">企业类型</el-col>
            <el-col :span="7">{{ disposal('企业类型') }}</el-col>
            <el-col :span="5">营业期限</el-col>
            <el-col :span="7">{{disposal('营业期限') }}</el-col>
          </el-row>

          <el-row>
            <el-col :span="5">所属行业</el-col>
            <el-col :span="19">{{disposal('所属行业')}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">注册地址</el-col>
            <el-col :span="19">{{ disposal('注册地址') }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="5">经营范围</el-col>
            <el-col :span="19">{{ disposal('经营范围') }}</el-col>
          </el-row>
        </div>
      </title-block>
    </MySkeleton>

    <MySkeleton :id="'bm'+titles[2].label" @update="_ => handleCurrentChange(1, 2)">
      <title-block v-if="titles[2].num && activeInfo">
        <template slot="title">{{titles[2].label}}</template>
        <div class="tables mt-10" style="margin-top:16px">
          <el-table :data="tableDatas(titles[2].moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <el-table-column type="index" label="序号" align="center" width="70" />
            <template v-for="(item, i) in tableFields(titles[2].moduleId)">
              <el-table-column v-if="item.field != 'rk'" :key="i" :label="item.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{ columnValue(scope.row[i], titles[2].moduleId)}}</template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="titles[2].pageNum" :total="tableTotal(titles[2].moduleId)" @currentChange="val => handleCurrentChange(val, 2)" />
        </div>
      </title-block>
    </MySkeleton>

    <MySkeleton :id="'bm'+titles[3].label" @update="_ => handleCurrentChange(1, 3)">
      <title-block v-if="titles[3].num && activeInfo">
        <template slot="title">{{titles[3].label}}</template>
        <div class="holderInfo mt-10" style="margin-top:16px">
          <div class="infoWrap">
            <div class="basicInfo" v-for="(item,i) in tableDatas(titles[3].moduleId)" :key="i">
              <template v-for="(item2, ii) in tableFields(titles[3].moduleId)">
                <p v-if="item2.field != 'rk'" :key="ii" style="color: #666666;line-height: 18px;font-size: 13px;padding-left:17px;padding-right:35px">
                  <span>{{item2.fieldName}}：</span>
                  <overflow-tooltip :title="item[ii]||'--'" style="text-align: right;"></overflow-tooltip>
                </p>
              </template>
            </div>

          </div>
          <pagination :pageNum="titles[3].pageNum" :total="tableTotal(titles[3].moduleId)" @currentChange="val => handleCurrentChange(val, 3)" />
        </div>
      </title-block>
    </MySkeleton>

    <MySkeleton :id="'bm'+titles[4].label" @update="_ => handleCurrentChange(1, 4)">
      <title-block v-if="titles[4].num && activeInfo">
        <template slot="title">{{titles[4].label}}</template>
        <div class="mt-10" style="margin-top:16px">
          <el-table :data="tableDatas(titles[4].moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}">
            <el-table-column type="index" label="序号" align="center" width="70" />
            <template v-for="(item, i) in tableFields(titles[4].moduleId)">
              <el-table-column v-if="item.field != 'rk'" :key="i" :label="item.fieldName.replace('记录', '')" align="center">
                <template slot-scope="scope">
                  <el-tooltip v-if="columnValue(scope.row[i], titles[4].moduleId) != '--'" class="item" effect="light" :content="columnValue(scope.row[i], titles[4].moduleId)" placement="top">
                    <p class="textOverflow">{{ columnValue(scope.row[i], titles[4].moduleId)}}</p>
                  </el-tooltip>
                  <p v-else>{{ columnValue(scope.row[i], titles[4].moduleId)}}</p>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="titles[4].pageNum" :total="tableTotal(titles[4].moduleId)" @currentChange="val => handleCurrentChange(val, 4)" />
        </div>
      </title-block>
    </MySkeleton>

    <template v-for="(item,i) in titles">
      <MySkeleton :key="i" :id="'bm'+item.label" v-if="i>=5 && i<7" @update="_ => handleCurrentChange(1, i)">
        <title-block v-if="item.num && activeInfo">
          <template slot="title">{{item.label}}</template>
          <div class="mt-10">
            <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}">
              <template v-for="(item1, j) in tableFields(item.moduleId)">
                <el-table-column v-if="item1.field != 'rk'" :key="j" :label="item1.fieldName" align="center">
                  <template slot="header">
                    <textOverflow width="70px">{{item1.fieldName}}</textOverflow>
                  </template>
                  <template slot-scope="scope">
                    <!-- {{whichType(scope.row[j])}} -->
                    <el-tooltip class="item" effect="light" :content="columnValue(scope.row[j], item.moduleId)" placement="top">
                      <span class="textOverflow" v-if="whichType(scope.row[j])==='string'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                      <span class="textOverflow" v-else-if="whichType(scope.row[j])==='array'" v-html="columnValue(arrParse(scope.row[j]), item.moduleId)"></span>
                      <span class="textOverflow" v-else-if="whichType(scope.row[j])==='object'">{{columnValue(JSON.parse(scope.row[j]).value, item.moduleId)}}</span>
                      <span v-else>--</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </template>
            </el-table>
            <pagination :pageNum="item.pageNum" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
          </div>
        </title-block>
      </MySkeleton>

    </template>

    <!-- 企业年报 -->
    <MySkeleton :id="'bm'+titles[7].label" @update="_ => handleCurrentChange(1, 7)">
      <title-block v-if="titles[7].num && activeInfo">
        <template slot="title">{{titles[7].label}}</template>
        <div class="mt-10" style="margin-top:16px">
          <el-table :data="tableDatas(titles[7].moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <el-table-column type="index" label="序号" align="center" width="70" />
            <template v-for="(item, i) in tableFields(titles[7].moduleId)">
              <el-table-column v-if="item.field !='hid' && item.field !='id'" :key="i" :label="item.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ columnValue(scope.row[i], titles[7].moduleId)}}
                </template>
              </el-table-column>
            </template>
            <el-table-column label="操作" align="center">
              <template slot-scope="{$index}">
                <span style="color: #5088FF;font-size:13px;cursor: pointer;" @click="goDetail( disposal('年报年份',405, $index),titles[7].moduleId,hid,companyName)">详情</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination :pageNum="titles[7].pageNum" :total="tableTotal(titles[7].moduleId)" @currentChange="val => handleCurrentChange(val, 7)" />
        </div>
      </title-block>
    </MySkeleton>

    <!-- 临时隐藏 相似企业 -->
    <!-- <MySkeleton :id="'bm'+titles[8].label">
      <title-block v-if="false && titles[8].num">
        <template slot="title">{{titles[8].label}}</template>
        <div class="tables mt-10" style="margin-top:16px">
          <el-table :data="same" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(it, i) in sameOptions">
              <el-table-column :key="i" :label="it.label" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row[it.key]}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="pageNum" :total="sameTotal" @currentChange="similarCompanyList" />
        </div>
      </title-block>
    </MySkeleton> -->

    <!-- 企业年报详情 -->
    <yearReportDetail ref="yearReport"></yearReportDetail>

    <MySkeleton id="bm企业评分">
      <title-block>
        <template slot="title">企业评分</template>
        <EnterpriseRate :data="{hid,companyName}" />
      </title-block>
    </MySkeleton>
  </div>
</template>

<script>
import { fields as constFields, value as realValue, isFunc } from '@/views/clue/api/fields'
import overflowTooltip from '@/views/clue/components/overflowTooltip'
import { companyBrief, similarCompanyList } from '../api/newClueApi.js'
import annualReport from './annualReportsDialog' // 企业年报的弹框
import mixin from '../mixins/enterpriseTabs'
import yearReportDetail from '../dialog/yearReportDetail'
import EnterpriseRate from '@/views/clue/components/enterpriseRate'
import EnterpriseGraphTab from '@/views/clue/components/enterpriseGraphTab'
import intersectionObserver from './../../../mixins/intersectionObserver.js'
export default {
  mixins: [mixin, intersectionObserver],
  name: 'basicMsg',
  components: {
    annualReport,
    overflowTooltip,
    yearReportDetail,
    EnterpriseRate,
    EnterpriseGraphTab
  },
  props: {
    tabsInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      titles: [
        { type: '', label: '企业简介', num: 0, moduleId: '' },
        { type: '', label: '工商信息', num: 0, moduleId: '' }, //
        { type: '', label: '高管信息', num: 0, moduleId: '', pageNum: 1 }, //
        { type: '', label: '股东信息', num: 0, moduleId: '', pageNum: 1 }, //
        { type: '', label: '变更信息', num: 0, moduleId: '', pageNum: 1 }, //
        { type: '', label: '对外投资', num: 0, moduleId: '', pageNum: 1 }, //
        { type: '', label: '分支机构', num: 0, moduleId: '', pageNum: 1 }, // 
        { type: '', label: '企业年报', num: 0, moduleId: '', pageNum: 1 }, //
        { type: '', label: '企业评分', num: 1, moduleId: '' }
      ],
      brief: '',
      briefAll: '',
      showMoreText: false,
      same: [],
      sameOptions: [
        { label: '公司名称', key: 'companyName' },
        { label: '相似度', key: 'similarity' }
      ],
      pageNum: 1,
      sameTotal: 0,
      hid: '',//年报详情使用
      companyName: '',//年报详情使用
    }
  },
  mounted() {
    this.getBrief()
    // this.similarCompanyList()  // 临时隐藏 相似企业 
    this.hid = this.$parent.$parent.companyStatus.hid
    this.companyName = this.$parent.$parent.companyStatus.companyName



  },
  methods: {
    goDetail(year, moduleId, hid, companyName) {
      this.$refs.yearReport.showDialog(year, moduleId, hid, companyName)
    },
    disposal(str, moduleId = 482, index = 0) {
      if (!this.activeInfo) return '--'
      if (!this.activeInfo.length) return '--'
      const [data] = this.activeInfo.filter(v => v.moduleId == moduleId)
      if (!data) return '--'
      const { isNew, fieldData, fields, fieldsMap } = data
      // if (isNew) {
      if (!fieldData || !fieldData.length) return '--'
      const showAction = constFields[moduleId][str]
      const valueFunc = v => fieldData[index][fieldsMap[v]?.idx]
      if (isFunc(showAction)) { return showAction(valueFunc) }
      return realValue(valueFunc(str))
    },
    getBase(val) {
      var base = '--'
      if (val) {
        for (var i = 0; i < this.areaCode.length; i++) {
          if (val === this.areaCode[i].base) {
            base = this.areaCode[i].name
            break
          }
        }
      }
      return base
    },
    async getBrief() {
      const { data } = await companyBrief({ companyName: this.$parent.$parent.companyStatus.companyName, hid: this.$parent.$parent.companyStatus.hid })
      if (data && data.length > 136) {
        this.brief = data.substr(0, 136) + '...'
        this.showMoreText = true
      } else {
        this.brief = data
      }
      this.briefAll = data
      this.titles[0].num = data ? 1 : 0
    },
    showMore() {
      this.brief = this.briefAll
      this.showMoreText = false
    },
    async similarCompanyList(page) {
      if (page) {
        this.pageNum = page
      }
      const { data } = await similarCompanyList({ companyName: this.$parent.$parent.companyStatus.companyName, pageNum: this.pageNum })
      this.same = data.list
      this.titles[9].num = data.total
      this.sameTotal = data.total
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-table__empty-block {
    width: 100% !important;
  }
}
.brief {
  font-size: 12px;
  padding: 10px;
  padding-top: 16px;
  .showMoreText {
    font-size: 12px;
    color: #4f7afd;
    line-height: 22px;
    cursor: pointer;
  }
}
.table {
  border: 1px solid #e1e7ed;
  font-size: 12px;
  .el-row + .el-row {
    border-top: 1px solid #e1e7ed;
  }
  .el-row {
    display: flex;
    .el-col {
      font-size: 12px;

      padding: 10px;
      color: #666666;
      display: inline-flex;
      align-items: center;
    }
    .el-col-5 {
      background: #fafafa;
      color: rgba(52, 57, 81, 0.8);
      width: 137px;
    }
    .el-col + .el-col {
      border-left: 1px solid #e1e7ed;
    }
  }
}
/deep/ .el-table th > .cell {
  font-size: 13px;
  font-weight: 400;
  font-weight: bold;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}

/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}

.tables /deep/ .el-table__header {
  width: 100% !important;
}
.tables /deep/ .el-table__body {
  width: 100% !important;
}

.holderInfo {
  .infoWrap {
    display: flex;
    flex-wrap: wrap;
    .basicInfo {
      width: 313px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #f1f1f2;
      // padding: 16px;
      margin: 0 8px 8px 0;
      margin-right: 16px;
      padding-bottom: 16px;
      > p {
        font-size: 12px;
        color: #666;
        line-height: 12px;
        margin: 0 0 8px;
        &:first-child {
          color: #333;
        }
        &:last-child {
          margin-bottom: 0;
        }
        display: flex;
        span:first-child {
          flex-grow: 0;
          flex-shrink: 0;
        }
        span {
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 12px;
        }
      }
      p:first-child {
        background: #f7f7fa;
        height: 50px;
        line-height: 50px !important;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        /deep/ span {
          text-align: left !important;
        }
      }
      &:nth-of-type(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>
